import { render, staticRenderFns } from "./cancelStake.vue?vue&type=template&id=5c30ba12&"
import script from "./cancelStake.vue?vue&type=script&lang=js&"
export * from "./cancelStake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c30ba12')) {
      api.createRecord('5c30ba12', component.options)
    } else {
      api.reload('5c30ba12', component.options)
    }
    module.hot.accept("./cancelStake.vue?vue&type=template&id=5c30ba12&", function () {
      api.rerender('5c30ba12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/fullNode/cancelStake.vue"
export default component.exports